const international = {
  hero: {
    eyebrow: "Global portfolio",
    title:   "International",
    titleEm: "Properties",
    sub:     "Exclusive listings beyond the UAE — curated by ProNet Real Estate.",
  },
  filter: {
    all: "All",
  },
  count_one:   "{{count}} property",
  count_other: "{{count}} properties",
  card: {
    bedrooms:  "beds",
    bathrooms: "baths",
  },
  detail: {
    forSale:        "For sale",
    breadcrumb:     "International",
    bedrooms:       "Bedrooms",
    bathrooms:      "Bathrooms",
    builtArea:      "m² built",
    plotArea:       "m² plot",
    description:    "Description",
    amenities:      "Amenities & Features",
    details:        "Details",
    type:           "Type",
    status:         "Status",
    location:       "Location",
    builtAreaLabel: "Built area",
    plotAreaLabel:  "Plot area",
    priceIn:        "Price in {{currency}}",
    whatsapp:       "WhatsApp agent",
    viewSite:       "View property website ↗",
    allPhotos:      "All photos",
    viewAll_one:    "View all {{count}} photo",
    viewAll_other:  "View all {{count}} photos",
    notFound:       "Listing not found",
    back:           "← Back to International",
  },
};

export default international;
